import styled from 'styled-components'

import { helpers } from 'styles'

import { Heading } from 'components/Heading'

export const PropertyTitle = styled(Heading)`
	padding-bottom: 8px;
	margin-bottom: 0;
	border-bottom: 1px solid ${helpers.color.separator};
`
